import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .circle-outside {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 75rem;
    width: 75rem;
    border-radius: 50%;
    background-color: #f7f7f7;

    .circle-inside {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60rem;
      width: 60rem;
      border-radius: 50%;
      background-color: #fafafa;
    }
  }

  @media (max-width: 600px) {
    .circle-outside {
      height: 100%;
      width: 100%;

      .circle-inside {
        height: 80%;
        width: 80%;
      }
    }
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 2.4rem;
  background-color: #fff;
  padding: 3.6rem 3.6rem 4.2rem;
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.1);
  z-index: 10;
  width: 90%;
  max-width: 40rem;

  img {
    width: 80%;
    align-self: center;
    margin-bottom: 10rem;
  }
`;
